const DB_NAME = 'punchtm-kiosk-offline';
const DB_VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains('employees')) {
        db.createObjectStore('employees', { keyPath: 'employeeCode' });
      }
      if (!db.objectStoreNames.contains('punchQueue')) {
        db.createObjectStore('punchQueue', { keyPath: 'localId', autoIncrement: true });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Cache employees for offline lookup
export async function cacheEmployees(tenantId, employees) {
  const db = await openDB();
  const tx = db.transaction('employees', 'readwrite');
  const store = tx.objectStore('employees');
  store.clear();
  employees.forEach((emp) => store.put({ ...emp, tenantId, cachedAt: Date.now() }));
  return new Promise((resolve) => { tx.oncomplete = resolve; });
}

// Find employee by code from cache
export async function findCachedEmployee(code) {
  const db = await openDB();
  const tx = db.transaction('employees', 'readonly');
  const store = tx.objectStore('employees');
  return new Promise((resolve, reject) => {
    const request = store.get(code);
    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
  });
}

// Queue a punch for later sync
export async function queuePunch(punchData) {
  const db = await openDB();
  const tx = db.transaction('punchQueue', 'readwrite');
  const store = tx.objectStore('punchQueue');
  store.add({ ...punchData, queuedAt: new Date().toISOString() });
  return new Promise((resolve) => { tx.oncomplete = resolve; });
}

// Get all queued punches
export async function getQueuedPunches() {
  const db = await openDB();
  const tx = db.transaction('punchQueue', 'readonly');
  const store = tx.objectStore('punchQueue');
  return new Promise((resolve) => {
    const request = store.getAll();
    request.onsuccess = () => resolve(request.result || []);
  });
}

// Remove a punch from queue after successful sync
export async function removePunchFromQueue(localId) {
  const db = await openDB();
  const tx = db.transaction('punchQueue', 'readwrite');
  const store = tx.objectStore('punchQueue');
  store.delete(localId);
  return new Promise((resolve) => { tx.oncomplete = resolve; });
}

// Get queue count
export async function getQueueCount() {
  const db = await openDB();
  const tx = db.transaction('punchQueue', 'readonly');
  const store = tx.objectStore('punchQueue');
  return new Promise((resolve) => {
    const request = store.count();
    request.onsuccess = () => resolve(request.result);
  });
}
